import { IBetPosition } from '../../../../types/reducers/betPosition';
import { IBetPositionResponse } from '../../../../repositories/auction/entities/AnnouncementsBets/BetPositionResponse';

export function mapBetPosition(betPosition: IBetPositionResponse): IBetPosition {
  const { page, offerPosition } = betPosition;

  return {
    page: page || null,
    offerPosition: offerPosition || null,
  };
}
